import React from 'react';
import LeftBar from '../Components/LeftBar';
import Dashnav from '../Components/Dashnav';
import StudentsGraduatingComp from './StudentsGraduatingComp';

function StudentsGraduating() {
  return (
    <div className='mainContainer'>
      <LeftBar/>
      <div className='theMainContainer'>
        <Dashnav/>
        <StudentsGraduatingComp/>
      </div>
    </div>
  );
}

export default StudentsGraduating;
